import $ from 'jquery';

const svgTag = async el => {
    const data = await loadSvgFile(el.data('url'));
    data && el.replaceWith(new XMLSerializer().serializeToString(data.documentElement));
};

const loadSvgFile = async path => {
    try {
        const data = await $.ajax({
            url: path,
            type: 'GET',
        });

        return data;
    } catch (e) {
        console.log(e);
        return null;
    }
};

export const reloadScriptSvgLazy = () => {
    const $svgEl = $('.svg-lazy');

    $svgEl.each(function () {
        svgTag($(this));
    });
};
reloadScriptSvgLazy();
